export default __webpack_public_path__ + "static/media/speaker1.e218ba10.png";